import { h, Component, createRef } from "preact"
import { Slider } from "./slider"
import { SelectionButtons } from "./buttons"
import { GoogleMap } from "./google-map"
import { breakpoints } from "../../util/breakpoints"

export class PlacesApp extends Component {
  locationsMarkers = this.props.markers.locations
  partnersMarkers = this.props.markers.partners
  partnersAndLocationsMarkers = [
    ...this.partnersMarkers,
    ...this.locationsMarkers,
  ]

  currentBreakpoint = breakpoints()
  placesRef = createRef()

  initialLocationsElement =
    this.props.activeOverride.type === "locations"
      ? this.props.activeOverride.id
      : this.locationsMarkers[0]?.id
  initialPartnersElement =
    this.props.activeOverride.type === "partners"
      ? this.props.activeOverride.id
      : this.partnersMarkers[0]?.id

  getLocationsSliderData = (id) => {
    this.setState({ locationsSliderData: false })
    this.props
      .getDetailData(id, "locations")
      .then((_data) => this.setState({ locationsSliderData: _data }))
  }

  getPartnersSliderData = (id) => {
    this.setState({ partnersSliderData: false })
    this.props
      .getDetailData(id, "partners")
      .then((_data) => this.setState({ partnersSliderData: _data }))
  }

  state = {
    activeLocations: this.initialLocationsElement,
    activePartners: this.initialPartnersElement,
    locationsSliderData: this.getLocationsSliderData(
      this.initialLocationsElement,
    ),
    partnersSliderData: this.getPartnersSliderData(this.initialPartnersElement),
  }

  activatePartners = (id) => {
    this.setState({ activePartners: id })
    if (this.currentBreakpoint === "large") {
      this.setState({ activeLocations: "" })
    }
    this.getPartnersSliderData(id)
  }

  activateLocations = (id) => {
    this.setState({ activeLocations: id })
    if (this.currentBreakpoint === "large") {
      this.setState({ activePartners: "" })
    }
    this.getLocationsSliderData(id)
  }

  activate = (id, type) => {
    if (type) {
      switch (type) {
        case "locations":
          this.activateLocations(id)
          break
        case "partners":
          this.activatePartners(id)
          break
        default:
          throw Error("unrecognized category name")
      }
    }
  }

  activateAndOpenModalFunction = (activeElement, type) => {
    this.activate(activeElement, type)
    this.props.openModalFunction(activeElement, type)
  }

  componentWillReceiveProps({ activeOverride }) {
    const { id, type } = activeOverride
    if (id != this.state.activeLocations && type === "locations") {
      this.activateAndOpenModalFunction(id, type)
    }
    if (id != this.state.activePartners && type === "partners") {
      this.activateAndOpenModalFunction(id, type)
    }
  }

  componentDidMount() {
    const { id, type } = this.props.activeOverride
    if (id && ["partners", "locations"].includes(type)) {
      this.activateAndOpenModalFunction(id, type)
      this.placesRef.current.scrollIntoView({ behavior: "smooth" })
    }

    window.addEventListener(
      "resize",
      () => {
        if (breakpoints() != this.currentBreakpoint) {
          this.currentBreakpoint = breakpoints()
          this.forceUpdate()
        }
      },
      true,
    )
  }

  render(props, state) {
    return (
      <div
        id="places-app"
        class="columns margin--bottom farmers-section places"
        ref={this.placesRef}
      >
        <div class="farmers__teaser">
          <div class="farmers__teaser-item locations">
            <span class="din-serif--large">{props.locations.heading}</span>
            {props.activeOverride?.type === "locations" &&
              this.currentBreakpoint !== "large" &&
              props.children}
            <p>{props.locations.text}</p>
            {this.currentBreakpoint === "large" ? (
              <SelectionButtons
                buttons={this.locationsMarkers}
                active={state.activeLocations}
                activateAll={
                  state.activeLocations === undefined &&
                  state.activePartners === undefined
                }
                activate={this.activateAndOpenModalFunction}
              />
            ) : (
              <Slider
                elements={this.locationsMarkers}
                active={state.activeLocations}
                type="locations"
                activate={this.activateLocations}
                data={state.locationsSliderData}
                openModalFunction={props.openModalFunction}
                translations={props.translations}
                fakeSlide={[
                  props.locations.heading,
                  props.locations.mobile_text,
                ]}
              />
            )}
          </div>
          <div class="farmers__teaser-item partners">
            <span class="din-serif--large">{props.partners.heading}</span>
            <p>{props.partners.text}</p>
            {props.activeOverride?.type === "partners" &&
              this.currentBreakpoint !== "large" &&
              props.children}
            {this.currentBreakpoint === "large" ? (
              <SelectionButtons
                buttons={this.partnersMarkers}
                active={state.activePartners}
                activateAll={
                  state.activeLocations === undefined &&
                  state.activePartners === undefined
                }
                activate={this.activateAndOpenModalFunction}
              />
            ) : (
              <Slider
                elements={this.partnersMarkers}
                active={state.activePartners}
                type="partners"
                activate={this.activatePartners}
                data={state.partnersSliderData}
                openModalFunction={props.openModalFunction}
                translations={props.translations}
                fakeSlide={[props.partners.heading, props.partners.mobile_text]}
              />
            )}
          </div>
        </div>
        <div class="farmers__map">
          {this.currentBreakpoint === "large" && props.children}
          <GoogleMap
            actives={[
              { id: state.activeLocations, type: "locations" },
              { id: state.activePartners, type: "partners" },
            ]}
            class={"places"}
            markers={this.partnersAndLocationsMarkers}
            visibleMarkers={this.partnersAndLocationsMarkers}
            initiallyActivateAll={true}
            activate={this.activateAndOpenModalFunction}
            scope={[12.3714, -1.5197, 2]}
          />
        </div>
      </div>
    )
  }
}
